import clsx from 'clsx';
import type { IconProps } from '../components/types.js';
import { fgTone } from '../utils/style/tone.js';
const displayName = 'IconArrowDownBold';
/** Renders an SVG icon. */
const SvgArrowDownBold = ({
  size,
  'aria-hidden': ariaHidden,
  tone,
  UNSAFE_className,
  UNSAFE_style,
  ...rest
}: IconProps) => {
  const props = {
    ...rest,
    'aria-hidden': ariaHidden ?? (rest['aria-label'] == null && rest['aria-labelledby'] == null),
    className: clsx('cim-icon', tone && fgTone(tone), UNSAFE_className),
    style: UNSAFE_style,
    width: size != null ? size + 'px' : '1em',
    height: size != null ? size + 'px' : '1em',
  };
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32" data-icon="true" fill="currentColor" {...props}>
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M16 2a2 2 0 0 1 2 2v18.788l5.513-6.126a2 2 0 0 1 2.974 2.676l-9 10a2 2 0 0 1-2.974 0l-9-10a2 2 0 1 1 2.974-2.676L14 22.788V4a2 2 0 0 1 2-2"
      />
    </svg>
  );
};
SvgArrowDownBold.displayName = displayName;
export default SvgArrowDownBold;
